// extracted by mini-css-extract-plugin
export default {"overlay":"WF-z","bodyOpen":"XF-z","content":"YF-z","header":"ZF-z","close":"_F-z","closeNoHeading":"aG-z"};